import pump from './pump.png';
import storeExt from './store-ext.png';

export const StoreBackShadowSprite = (
  <rect width="810" height="410" opacity="0.2" />
);

export const StoreGroundSprite = (
  <>
    <line x1={280} y1={1175} x2={1440} y2={1175} stroke="#c9a164" strokeWidth={10} />
    <path
      fill="#c9a164"
      stroke="#77964a"
      strokeWidth="10"
      d="M1445 1175a60 60 0 01-60-60h0a60 60 0 0160-60h680a109.25 109.25 0 00109.25-109.25v-311.5A109.25 109.25 0 002125 525H134.68A129.68 129.68 0 005 655.41c.45 79.73.45 189.45 0 269.17A129.69 129.69 0 00134.68 1055h130.75a60 60 0 0160 60h0a60 60 0 01-60 60"
    />
    <rect
      width="760"
      height="160"
      x="535"
      y="705"
      fill="#e5e2df"
      stroke="#603813"
      strokeWidth="4"
      rx="3.34"
    />
    <rect
      width="760"
      height="150"
      x="535"
      y="705"
      fill="#e5e2df"
      stroke="#603813"
      strokeWidth="2"
      rx="3.23"
    />
    <rect
      width="2180"
      height="500"
      x="25"
      y="5"
      fill="#e5e2df"
      stroke="#77964a"
      strokeWidth="10"
      rx="10"
    />
    <rect x="1240" width="820" height="250" fill="#6b492e" stroke="#56361e" strokeWidth="4" />
  </>
);

export const TiresSprite = (
  <>
    <path
      fill="#333"
      stroke="#000"
      d="M75.5.5C34.08.5.5 11.69.5 25.5V63c0 13.81 33.58 25 75 25s75-11.19 75-25V25.5c0-13.81-33.58-25-75-25z"
    />
    <ellipse
      cx="75.5"
      cy="25.5"
      fill="#9e6739"
      stroke="#603813"
      strokeWidth="4"
      rx="50"
      ry="16.67"
    />
  </>
);

export const PumpSprite = (
  <image href={pump} />
);

export const StoreExtSprite = (
  <image href={storeExt} />
);
